import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import { z } from 'zod';

const internalCategoryFormSchema = z.object({
    name: z.string().min(1).max(30),
});

export type InternalCategoryForm = z.infer<typeof internalCategoryFormSchema>;

// Form hook
export const useInternalCategoryForm = (defaultValues?: Partial<InternalCategoryForm>) => {
    const form = useForm<InternalCategoryForm>({
        resolver: zodResolver(internalCategoryFormSchema),
        defaultValues: {
            ...defaultValues,
        },
    });

    return form;
};
